/**
 * Baja el font-size solo si el ancho *intrínseco* del título (una línea) supera el cupo
 * (evita el bug de scrollWidth=ancho de caja al usar spans width:100%).
 */
(function () {
  'use strict';

  var SELECTOR =
    '.mega-menu-crocs-style--by-style-grid .mega-menu-accessories-grid .titulo-menu-accesorios,' +
    ' .mega-menu-crocs-style--by-style-grid .mega-menu-popular-grid .titulo-menu-accesorios,' +
    ' .mega-menu-crocs-jibbits .mega-menu-jibbits-item > span.titulo-menu-accesorios';

  var MIN_PX = 9;
  var STEP = 0.25;
  var TOL = 0.5;

  var scheduleToken = 0;
  var mobileClassObserver = null;

  function getLabels(root) {
    return (root && root.querySelectorAll ? root : document).querySelectorAll(SELECTOR);
  }

  function measureIntrinsicTextWidth(text, cs, fontSizePx) {
    var m = document.createElement('span');
    m.setAttribute('aria-hidden', 'true');
    m.style.setProperty('position', 'absolute', 'important');
    m.style.setProperty('left', '-9999px', 'important');
    m.style.setProperty('top', '0', 'important');
    m.style.setProperty('visibility', 'hidden', 'important');
    m.style.setProperty('white-space', 'nowrap', 'important');
    m.style.setProperty('max-width', 'none', 'important');
    m.style.setProperty('box-sizing', 'border-box', 'important');
    var fs = fontSizePx != null ? fontSizePx + 'px' : cs.fontSize;
    m.style.setProperty('font-size', fs, 'important');
    m.style.setProperty('font-family', cs.fontFamily, 'important');
    m.style.setProperty('font-weight', cs.fontWeight, 'important');
    m.style.setProperty('font-style', cs.fontStyle, 'important');
    m.style.setProperty('font-variant', cs.fontVariant, 'important');
    if (cs.letterSpacing && cs.letterSpacing !== 'normal') {
      m.style.setProperty('letter-spacing', cs.letterSpacing, 'important');
    }
    if (cs.textTransform && cs.textTransform !== 'none') {
      m.style.setProperty('text-transform', cs.textTransform, 'important');
    }
    m.textContent = text;
    (document.body || document.documentElement).appendChild(m);
    var w = m.offsetWidth;
    m.remove();
    return w;
  }

  function getAvailInner(span) {
    var w = span.clientWidth;
    if (w < 1 && span.parentElement) {
      w = span.parentElement.clientWidth;
    }
    var cs = getComputedStyle(span);
    var padL = parseFloat(cs.paddingLeft) || 0;
    var padR = parseFloat(cs.paddingRight) || 0;
    return Math.max(0, w - padL - padR);
  }

  function fitLabel(span) {
    if (!span || span.nodeType !== 1) {
      return;
    }
    var anchor = span.parentElement;
    if (!anchor) {
      return;
    }

    span.style.removeProperty('font-size');
    span.style.removeProperty('line-height');
    span.style.removeProperty('text-overflow');
    span.style.removeProperty('overflow');
    span.style.removeProperty('white-space');

    if (anchor.clientWidth < 1) {
      return;
    }

    var avail = getAvailInner(span);
    if (avail < 1) {
      return;
    }

    var text = (span.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) {
      return;
    }

    var cs = getComputedStyle(span);
    var textW = measureIntrinsicTextWidth(text, cs);

    if (textW <= avail + TOL) {
      return;
    }

    span.style.setProperty('white-space', 'nowrap', 'important');

    var size = parseFloat(cs.fontSize);
    if (!size || isNaN(size)) {
      size = 14;
    }

    for (;;) {
      var tw = measureIntrinsicTextWidth(text, cs, size);
      if (tw <= avail + TOL) {
        span.style.setProperty('font-size', size + 'px', 'important');
        return;
      }
      if (size <= MIN_PX + 0.01) {
        break;
      }
      var next = size - STEP;
      if (next < MIN_PX) {
        next = MIN_PX;
      }
      if (next >= size) {
        break;
      }
      size = next;
    }

    span.style.setProperty('font-size', MIN_PX + 'px', 'important');
    if (measureIntrinsicTextWidth(text, cs, MIN_PX) > avail + TOL) {
      span.style.setProperty('text-overflow', 'ellipsis', 'important');
      span.style.setProperty('overflow', 'hidden', 'important');
    }
  }

  function runIn(root) {
    var list = getLabels(root);
    for (var i = 0; i < list.length; i++) {
      fitLabel(list[i]);
    }
  }

  function scheduleRun(root) {
    scheduleToken += 1;
    var my = scheduleToken;
    requestAnimationFrame(function () {
      if (my !== scheduleToken) {
        return;
      }
      requestAnimationFrame(function () {
        if (my !== scheduleToken) {
          return;
        }
        runIn(root || document);
      });
    });
  }

  function bindMobileMenuObserver() {
    var mobile = document.getElementById('mobile-menu');
    if (!mobile || mobileClassObserver) {
      return;
    }
    mobileClassObserver = new MutationObserver(function () {
      scheduleRun(mobile);
    });
    mobileClassObserver.observe(mobile, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function getNav() {
    return document.querySelector('.thb-full-menu, .full-menu, header .thb-full-menu');
  }

  function megaInLi(li) {
    if (!li || !li.querySelector) {
      return false;
    }
    return (
      li.querySelector('.mega-menu-crocs-style--by-style-grid') || li.querySelector('.mega-menu-crocs-jibbits')
    );
  }

  function initNavListeners() {
    var nav = getNav();
    if (nav) {
      nav.addEventListener(
        'mouseover',
        function (e) {
          var t = e.target;
          if (!t || !t.closest) {
            return;
          }
          var li = t.closest('li.menu-item-has-children');
          if (!li || !nav.contains(li) || !megaInLi(li)) {
            return;
          }
          scheduleRun(li);
        },
        { passive: true }
      );
      nav.addEventListener(
        'focusin',
        function (e) {
          var t = e.target;
          if (!t || !t.closest) {
            return;
          }
          var li = t.closest('li.menu-item-has-children');
          if (li && megaInLi(li)) {
            scheduleRun(li);
          }
        },
        true
      );
    }
  }

  function onReady() {
    bindMobileMenuObserver();
    initNavListeners();
    scheduleRun();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev && ev.target) {
      scheduleRun(ev.target);
    } else {
      scheduleRun();
    }
  });

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      runIn();
    }, 150);
  }
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) {
        return;
      }
      if (t.closest('#mobile-menu')) {
        setTimeout(function () {
          var mobile = document.getElementById('mobile-menu');
          if (mobile) {
            scheduleRun(mobile);
          }
        }, 0);
        setTimeout(function () {
          var mobile = document.getElementById('mobile-menu');
          if (mobile) {
            scheduleRun(mobile);
          }
        }, 220);
      }
    },
    true
  );
})();
